import React, { forwardRef } from 'react';

import { Styled } from './styles';
import type { ControlContainerProps, ControlProps } from './types';

export type { ControlContainerProps, ControlProps } from './types';

type Props = ControlProps & ControlContainerProps & Record<string, any>;

export const Control = forwardRef<HTMLElement, Props>(({ containerClassName, containerStyle, ...props }, ref) => {
  const isValidIconDisplayed = props.valid;
  const hasSuffix = props.suffix || props.valid;
  return (
    <Styled.Container
      disabled={props.disabled}
      errored={props.errored}
      className={containerClassName}
      style={containerStyle}
    >
      {props.prefix && (
        <Styled.PrefixSuffix placement="left" disabled={props.disabled}>
          {props.prefix}
        </Styled.PrefixSuffix>
      )}
      <Styled.Control {...(props as any)} ref={ref as any} />
      {hasSuffix && (
        <Styled.PrefixSuffix placement="right">
          {isValidIconDisplayed ? (
            <Styled.ValidIcon size="m" placement="right" disabled={props.disabled} />
          ) : (
            props.suffix
          )}
        </Styled.PrefixSuffix>
      )}
    </Styled.Container>
  );
});
Control.displayName = 'Control';
